// extracted by extract-css-chunks-webpack-plugin
module.exports = {"createAccountNotification":"ozaSb","confirmationMsgSuccess":"Yugsq","confirmationMsgError":"iPSxE","confirmationMsgInfo":"NJYn4","icon":"_4Hpvf"};